module.exports = __webpack_public_path__ + "d65eb9e43e69451380e4f8677e7f5406.png";